var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[(!_vm.$route.path.includes('hts-code'))?_c('h4',{staticClass:"mb-3"},[_vm._v(" Loading Results "),(_vm.text.length > 0)?_c('span',[_vm._v("for "),_c('b',[_vm._v("\""+_vm._s(_vm.text)+"\"")])]):_vm._e()]):_vm._e(),_c('div',{staticClass:"spinner-load"},[_c('b-spinner',{attrs:{"variant":"primary","label":"loading"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }